import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { NewsletterItemFileInitialState, NewsletterItemFileLoad } from './newsletter-item-file.actions';
import { NewsletterItemFileState, NewsletterItemFileStateModel } from './newsletter-item-file.state';

@Injectable({ providedIn: 'root' })
export class NewsletterItemFileFacade {
  newsletterItemFileData$: Observable<NewsletterItemFileStateModel> = this.store.select(
    NewsletterItemFileState.getState,
  );
  loaded$: Observable<boolean> = this.store.select(NewsletterItemFileState.getLoaded);

  constructor(private store: Store) {}

  getNewsletterFileItem(newsletterFileId: string): void {
    this.store.dispatch(new NewsletterItemFileLoad(newsletterFileId));
  }

  setInitialState(): void {
    this.store.dispatch(new NewsletterItemFileInitialState());
  }
}
